import Vec2 from './Vec2'
import Auflager from './Auflager'
import { formatDefaultLocale } from 'd3'

export default class Knoten{
    /**
     * Klasse für Knoten
     * Die Koordinaten werden in einem Vec2 abgespeichert. 
     * @param {Knotenliste} list 
     * @param {number} x 
     * @param {number} y 
     * @param {Auflager} auflager 
     */
    constructor(list, x, y, auflager){
        this.Vec2 = new Vec2(x,y)
        this.Stabliste = []
        this.Freiheitsgrade = []
        this.Auflager = auflager || null
        this.list = list || null
        this.d3Node = undefined
    }
    set x(v){this.Vec2.x = v}
    set y(v){this.Vec2.y = v}    
    get x() {return this.Vec2.x}
    get y() {return this.Vec2.y}
    get x_formated(){return this.x.toLocaleString('de-DE',{minimumFractionDigits: 2})}
    get y_formated(){return this.y.toLocaleString('de-DE',{minimumFractionDigits: 2})}
    set x_formated(v) { this.x = parseFloat(v.replace(',','.'))}
    set y_formated(v) { this.y = parseFloat(v.replace(',','.'))}    
    get number() {
        if(this.list) return this.list.indexOf(this)+1
        else return null
    }
    get auflagerName() { return this.Auflager ? this.Auflager.name : null}
    get name() { return 'Knoten Nr. ' + this.number }
    get info() { return this.name + ' X: '+this.x.toLocaleString('de-DE',{minimumFractionDigits: 2}) + '; Y: ' +this.y.toLocaleString('de-DE',{minimumFractionDigits: 2})}
    release_bindings(){ 
        //Vor dem Löschen des Knotens müssen die Verknüpfungen zu dem Knoten gelöscht werden.
        if (this.Auflager) this.Auflager.delete_Knotenverknüpfung(this) 
        //Die Verknüpfung mit den Knotenlasten werden im übergeordneten Objekt StatikSystem gelöst
    }
    add_Stabverknüpfung(stab){this.Stabliste.push(stab)}
    delete_Stabverknüpfung(stab){
        if (this.Stabliste.indexOf(stab)==-1) return console.log('Stab nicht in Liste')
        this.Stabliste.splice(this.Stabliste.indexOf(stab),1)}
}
